export var IDENTIFIER_TAB = 'tabs';
export var IDENTIFIER_TAB_ITEM = 'tabs-item';
